<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stock" />
        <MenuStockList/>
        <MaterialNowList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import MaterialNowList from '@/components/menuadmin/stock/stocklist/MaterialNowList.vue'

export default {
    name:'materialNow',
    components:{
        HeaderStock,
        MenuStockList,
        MaterialNowList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>